// Google Analytics 4 (gtag.js) helper.
// Set REACT_APP_GA_MEASUREMENT_ID in .env.local / your host's env vars.
// Every function below is a no-op when the id is missing, so local dev and
// forks without an id keep working untouched.

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

const isEnabled = () =>
  typeof window !== 'undefined' && Boolean(MEASUREMENT_ID);

export const initAnalytics = () => {
  if (!isEnabled() || initialized) return;
  initialized = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  // gtag must forward `arguments`, so no arrow function here.
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  // Page views are sent manually so this SPA's client-side routing is tracked.
  gtag('config', MEASUREMENT_ID, { send_page_view: false });
};

export const trackPageView = (path, title) => {
  if (!isEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: title || document.title,
  });
};

export const trackEvent = (name, params = {}) => {
  if (!isEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
};

export const isAnalyticsEnabled = isEnabled;
